import * as React from "react";
import { hot } from "react-hot-loader";
import ModalObligatoryMention from '../Modal/ModalObligatoryMention';
declare var libelle: any;


class Footer extends React.Component<{}, {}> {
  public render() {
    return (
      <footer id="footer" className="d-flex justify-content-center">
        <div className="align-self-center text-center">
          <span>{libelle.footer.copyright}</span>
          <span> | </span>
          <span dangerouslySetInnerHTML={{ __html: libelle.footer.siteEnmUrl }} />
          <span> | </span>
          <span><a href="" data-toggle="modal" data-target="#modalObligatoryMention">{libelle.footer.obligatoryMentions}</a></span>
          <span> | </span>
          <span dangerouslySetInnerHTML={{ __html: libelle.footer.help }} />
          <span> | </span>
          <span dangerouslySetInnerHTML={{ __html: libelle.footer.contact }} />
          <span> | </span>
          <span className="pr-2"><a href={libelle.footer.facebookUrl} target="_blank"><img src="./assets/f-ogo_RGB_HEX-58.png" width='28px' alt="Logo Facebook" /></a></span>
          <span><a href={libelle.footer.twitterUrl} target="_blank"><img src="./assets/Twitter_Logo_WhiteOnBlue.png" width='28px' alt="Logo Twitter" /></a></span>
        </div>
        <ModalObligatoryMention />
      </footer>
    );
  }
}

export default hot(module)(Footer);
